import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import cnaeSelector from "../store/cnae.selectors";
import solicitacaoSelector from "../../solicitacao/store/solicitacao.selectors";
import cnaeActions from "../store/cnae.actions";
import { ddadosCnae as DDados } from "../cnae.ddados";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import api from "../service/cnae.service";
import Panel from "@common/externos/components/panel/panel.component";
import CnaeGrid from "./cnae.grid";
import Button from "@material-ui/core/Button";
import decaSelector from "../../../store/deca.selectors";
import atividadeSelector from "../../atividades/store/atividade.selectors";
import atividadeActions from "../../atividades/store/atividade.actions";
import CpfCnpjValidator from "@common/validators/cpfCnpj.validator";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      blockDoubleClick: true,
    };

    this.arrayCnaesAssociados = [];
  }

  onSubmit(itens) {
    const { cnaes } = this.props.cnaeSelector.cnae;
    var multiplo = cnaes.length == 0;
    const promise = new Promise((resolve, reject) => {
      itens.forEach(async (item, index, array) => {
        await this.adicionar(item.data, index == 0 ? multiplo : false);
        if (index === array.length - 1) resolve();
      });
    });

    promise.then(() => {
      if (this.arrayCnaesAssociados.length > 0) {
        let message;
        const lastIndex = this.arrayCnaesAssociados.length - 1;
        const lastItem = this.arrayCnaesAssociados[lastIndex];
        this.arrayCnaesAssociados.splice(lastIndex, 1);

        if (this.arrayCnaesAssociados.length > 0) {
          message = this.arrayCnaesAssociados.join(", ");
          message = `${message} e ${lastItem}`;
        } else message = lastItem;

        _showError(`Esses itens já foram adicionados: ${message}.`);
        this.arrayCnaesAssociados = [];
      }
    });
  }

  async adicionar(item, multiplo) {
    const { cnaes } = await this.props.cnaeSelector.cnae;
    const { atividades } = await this.props.atividadeSelector.atividade;
    const { deca } = this.props.decaSelector;
    const { solicitacao } = this.props.solicitacaoSelector;
    const UtilizarVinculoCNAEAtividadenaSolicitacao = deca.registrarSolicitacao.parametro.find(
      (x) => x.Descricao == "UtilizarVinculoCNAEAtividadenaSolicitacao"
    );

    let itemCnae = {
      IdCnae: item.Id,
      Principal: multiplo,
      CodigoString: item.CodigoString,
      Descricao: item.Descricao,
    };

    if (
      atividades.length > 0 &&
      UtilizarVinculoCNAEAtividadenaSolicitacao &&
      UtilizarVinculoCNAEAtividadenaSolicitacao.Valor == "S" &&
      solicitacao.TipoSolicitacao == 1 &&
      CpfCnpjValidator.validarCPF(solicitacao.CpfCnpjSolicitacao)
    ) {
      var result = await _alert.confirm(
        "O sistema permite apenas inclusão de atividades vinculadas a CNAE. Ao incluir uma CNAE as Atividades preenchidas serão excluidas. Deseja continuar ?",
        "Atenção"
      );

      if (result) await this.props.atividadeActions.clearGridAtividade();
      else return;
    }

    if (this.state.blockDoubleClick) {
      if (cnaes.filter((x) => x.IdCnae == itemCnae.IdCnae).length != 0) {
        this.arrayCnaesAssociados.push(item.CodigoString);
      } else {
        await this.props.cnaeActions.addSagaCnae(itemCnae);
        this.setState({ blockDoubleClick: false });
        setTimeout(
          function () {
            this.setState({ blockDoubleClick: true });
          }.bind(this),
          1000
        );
      }
    }

    this.props.cnaeActions.AdicionaAutomaticamenteAtividadePorCnae();

  }

  render() {
    const { Campos } = DDados;
    const { prefix, form, disableAll, isView } = this.props;
    const { cnae } = this.props.cnaeSelector;
    const { solicitacao } = this.props.solicitacaoSelector;
    const encerramentoDesabilita =
      solicitacao.CCM != undefined && solicitacao.TipoSolicitacao == "3";

    return (
      <Panel title={"CNAE"} defaultExpanded={false}>
        <Row>
          <Col lg={"10"}>
            <DDadosItem
              name="Cnae"
              {...Campos.SuggestionCnae}
              service={api.suggestionCnae}
              mapTag={(item) => ({
                data: { ...item },
                selectedItem: item.Id + item.CodigoString,
                value: item.Exibicao,
                tooltip: item.Descricao,
              })}
              onChange={(itens) => {
                const data = itens.map((item) => {
                  return item.data;
                });
                this.props.cnaeActions.onChange(data);
              }}
              state={cnae}
              Desabilitado={encerramentoDesabilita || disableAll}
            />
          </Col>
          <Col lg={"2"}>
            <Button
              name={"adicionar"}
              variant="contained"
              color="primary"
              className={"d-inline mt-4"}
              disabled={!form || disableAll}
              onClick={() => this.onSubmit(form)}
            >
              Adicionar
              <i className={"fas fa-plus ml-2"} />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <CnaeGrid isView={isView} />
          </Col>
        </Row>
      </Panel>
    );
  }
}

export default connect({
  actions: {
    cnaeActions,
    atividadeActions,
  },
  selectors: {
    cnaeSelector,
    solicitacaoSelector,
    atividadeSelector,
    decaSelector,
  },
})(Container);
